import React, { useEffect, useState, Component } from 'react';
import {connect} from 'react-redux';
import EnvelopeOptions from './EnvelopeOptions.js';
import GraphicalEnvelope from './envelope/GraphicalEnvelope.js';
import EffectParameterSlider from 'components/effects/EffectParameterSlider.js';
import OscillatorComponent from './OscillatorComponent.js';
import Dropdown from 'react-dropdown'
import AmpEnvelopeComponent from './AmpEnvelopeComponent.js';
import EnvelopeComponent from './EnvelopeComponent.js';
import {AMP, OP_A, OP_B1, OP_B2, FILTER, FILTER_2, PITCH, MODULATION} from 'constants/envelope-types.js';

const EnvelopesComponent = (props) => {
    let [selectedOption, setSelectedOption] = useState("Amp");

    const getEnvelopeOption = (val) => {
        return props.envelopeOptions.filter(
            opt => opt.value === val)[0];
    };

    let instrument = props.instrument;
    const options = ["Amp", "Mods", "Filter", "Pitch"];

    let envelopes = {};
    if (instrument.oscillatorNodes[1] === undefined ||
        instrument.oscillatorNodes[2] === undefined ||
        instrument.oscillatorNodes[3] === undefined) {
        return (<div></div>);
    }

    switch (selectedOption) {
    case "Amp":
        envelopes["Amp"] = instrument.ampEnvelope;
        envelopes.hasRelease = true;
        break;
    case "Mods":
        if (instrument.oscillatorNodes[1].enabled) {
            envelopes["A"] = instrument.oscillatorNodes[1].ampEnvelope;
        }
        if (instrument.oscillatorNodes[2].enabled) {
            envelopes["B1"] = instrument.oscillatorNodes[2].ampEnvelope;
        }
        if (instrument.oscillatorNodes[3].enabled) {
            envelopes["B2"] = instrument.oscillatorNodes[3].ampEnvelope;
        }
        envelopes.hasRelease = false;
        break;
    case "Filter":
        envelopes["Low-pass"] = instrument.filterEnvelope;
        envelopes["Hi-pass"] = instrument.hpFilterEnvelope;
        envelopes.hasRelease = true;
        //envelopes.hasLevel = true;
        envelopes.hasDepth = true;
        break;
    case "Pitch":
        envelopes["Pitch"] = instrument.pitchEnvelope;
        envelopes.hasRelease = true;
        //envelopes.hasLevel = true;
        envelopes.hasDepth = true;
        break;
    }

    useEffect(() => {
        if (props.selectedParameter) {
            let context = props.selectedParameter.context;
            if (!context) {
                return;
            }
            if (context.subDevice) {
                let subDevice = context.subDevice;
                if (subDevice === instrument.pitchEnvelope) {
                    setSelectedOption("Pitch");
                } else if (subDevice === instrument.filterEnvelope ||
                          subDevice === instrument.hpFilterEnvelope) {
                    setSelectedOption("Filter");
                } else if (instrument.oscillatorNodes.slice(1).some(
                    osc => osc.ampEnvelope === subDevice)) {
                    setSelectedOption("Mods");
                } else if (instrument.ampEnvelope === subDevice) {
                    setSelectedOption("Amp");
                }
            }
        }
    }, [props.selectedParameter, setSelectedOption]);

    return (
        <div className="envelopes-component">
          <div className="envelope-options">
            {options.map(
                opt => 
                    <EnvelopeOptions
                      key={opt}
                      instrument={instrument}
                      onChange={(e) => setSelectedOption(e)}
                      option={opt}
                      isSelected={selectedOption === opt}
                    />)}
          </div>
          <div className="clear-fix"/>
          {Object
           .keys(envelopes)
           .filter(name => name !== "hasRelease" &&
                   name !== "hasDepth")
           .map(
               (name, i) => 
                   <div key={name + i}>
                     <GraphicalEnvelope
                       instrument={instrument}
                       key={name + i}
                       width={200}
                       fillColor={props.color}
                       lineColor={props.color}
                       sequencerEngine={props.sequencerEngine}
                       envelope={envelopes[name]}
                       name={name}
                       hasRelease={envelopes.hasRelease}
                       hasLevel={false}
                     />
                     {envelopes.hasDepth ?
                      <EffectParameterSlider
                        parameter={envelopes[name].levelParameter}
                        sequencerEngine={props.sequencerEngine}
                        isParameter={true}
                        name="Env Depth"
                        max={1}
                        min={-1}
                        step={0.01}
                      /> : ''}
                   </div>
           )}
        </div>
    );

};

const mapStateToProps = (state, props) => {
    return {
        selectedParameter: state.effects.accumulatorParameterSelected
    };
};

export default connect(mapStateToProps, null)(EnvelopesComponent);
